import React, { useContext, useState, useEffect } from 'react';
import { AnimatePresence } from 'motion/react';
import styled from 'styled-components';
import { FirebaseContext } from 'context';
import { Button } from 'components';
import { Container, Title, Card, Label, FormSelect } from '../Shared';

function ModeratorPermissions({ users, sessions, customDropdownMenuStyles }) {
  const { firebase } = useContext(FirebaseContext);
  const [sessionId, setSessionId] = useState('');
  const [formIncomplete, setFormIncomplete] = useState(true);
  const [grantingPermissions, setGrantingPermissions] = useState(false);
  const [removingPermissions, setRemovingPermissions] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [error, setError] = useState({
    code: '',
    message: ''
  });

  useEffect(() => {
    if (selectedUsers.length && sessionId) {
      setFormIncomplete(false);
    } else {
      setFormIncomplete(true);
    }
    if (error) {
      setError({
        code: '',
        message: ''
      });
    }
  }, [selectedUsers, sessionId]);

  const handleGrantUserModeratorPermissions = async () => {
    try {
      setGrantingPermissions(true);
      await firebase.admin.grantModeratorPermissions({
        uids: selectedUsers.map((_user) => _user.value.uid),
        sessionId: sessionId.value
      });
    } catch (_error) {
      console.error(_error);
    } finally {
      setSelectedUsers([]);
      setSessionId('');
      setGrantingPermissions(false);
    }
  };

  const handleRemoveUserModeratorPermissions = async () => {
    try {
      setRemovingPermissions(true);
      await firebase.admin.removeModeratorPermissions({
        uids: selectedUsers.map((_user) => _user.value.uid),
        sessionId: sessionId.value
      });
    } catch (_error) {
      console.error(_error);
    } finally {
      setSelectedUsers([]);
      setSessionId('');
      setRemovingPermissions(false);
    }
  };

  return users ? (
    <Container>
      <Title>Moderator Permissions</Title>
      <Card>
        <div>
          <Label>Select Users</Label>
          <FormSelect
            isMulti
            value={selectedUsers}
            onChange={setSelectedUsers}
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={users}
          />
        </div>
        <div>
          <Label>Session ID</Label>
          <FormSelect
            value={sessionId}
            onChange={setSessionId}
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={sessions}
          />
        </div>
        {/* <ErrorMessage
          errorMessage={error.message}
          style={{
            color: theme.className === 'contrast' ? theme.primary : '#F55151'
          }}
          variants={fadeInAndOutAndAnimateHeightVariants()}
        /> */}
        <ButtonWrapper>
          <AnimatePresence>
            <Button
              type="button"
              loading={grantingPermissions}
              disabled={formIncomplete}
              onClick={handleGrantUserModeratorPermissions}
              changeColorWhenDisabled={false}>
              Grant
            </Button>
          </AnimatePresence>
          <AnimatePresence>
            <Button
              type="button"
              loading={removingPermissions}
              disabled={formIncomplete}
              onClick={handleRemoveUserModeratorPermissions}
              changeColorWhenDisabled={false}>
              Remove
            </Button>
          </AnimatePresence>
        </ButtonWrapper>
      </Card>
    </Container>
  ) : (
    ''
  );
}

const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 0.75rem auto 0;

  > button {
    width: 110px;
  }
`;

export default ModeratorPermissions;
